import {DatePickerCalendar} from "@/components/datePicker/subComponents/DatePickerCalendar/DatePickerCalendar.tsx";
import {memo} from "react";

// Memoized the datepicker calendar component to prevent unnecessary re-renders when scrolling or resizing
export const MemoizedDatePickerCalendar = memo(DatePickerCalendar, (prevProps, nextProps) => {
  return (
    prevProps.selected === nextProps.selected &&
    prevProps.mode === nextProps.mode &&
    prevProps.fixedRange === nextProps.fixedRange &&
    prevProps.splitRole === nextProps.splitRole &&
    prevProps.name === nextProps.name &&
    prevProps.dateFormat === nextProps.dateFormat &&
    prevProps.timeFormat === nextProps.timeFormat &&
    prevProps.timezone === nextProps.timezone &&
    prevProps.onChange === nextProps.onChange &&
    prevProps.onCancel === nextProps.onCancel &&
    prevProps.onReset === nextProps.onReset &&
    prevProps.onDone === nextProps.onDone &&
    prevProps.disableFutureDates === nextProps.disableFutureDates &&
    prevProps.disablePastDates === nextProps.disablePastDates &&
    prevProps.hasTimeSelect === nextProps.hasTimeSelect &&
    prevProps.hasPopoverInput === nextProps.hasPopoverInput
  );
});
